import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../../../theme/colors";

const useStyles = makeStyles(() => ({
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: 16,
    width: "100%",
    padding: "24px 32px",
    background: colors.white,
    border: `1px solid ${colors.ideGrey100}`,
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)",
    borderRadius: 8,
    textAlign: "left",
  },
  logo: {
    height: 40,
  },
  description: {
    fontFamily: "Roboto",
    fontSize: 16,
    lineHeight: "24px",
    color: colors.darkBlue900,
  },
}));

export { useStyles };
